import { apiClient } from '../client';
import { Position } from '../../types/admin';

export const positionsApi = {
  list: () => apiClient.get<{ data: Position[] }>('/api/admin/positions'),
  create: (input: { title: string; departmentId?: number | null }) =>
    apiClient.post<{ data: { id: number } }>('/api/admin/positions', input),
  update: (id: number, input: { title: string; departmentId?: number | null }) =>
    apiClient.put<{ data: { id: number } }>(`/api/admin/positions/${id}`, input),
  deactivate: (id: number) => apiClient.patch<{ data: { id: number; is_active: boolean } }>(`/api/admin/positions/${id}/deactivate`),
};
